import React from 'react'
import { useEventFeedsContext } from '../context/index.jsx'

export const useIsSnapshot = () => {
  const { data } = useEventFeedsContext()
  return data?.deliveries?.[0]?.status === 'snapshot'
}

// This component will hide the child components in case the event feed is a snapshot
const ManageComponent = ({ children }) => {
  const isSnapshot = useIsSnapshot()

  return !isSnapshot && <React.Fragment>{children}</React.Fragment>
}

export default ManageComponent
